export default "__VITE_ASSET__Ht86ASpa__"